export const DecimalPlaces = {
  Usd: 2,
  Btc: 8,
} as const;
